import { Environment as D, Store as G, RecordSource as M } from "relay-runtime";
import { defaultConfig as T } from "./index9.mjs";
import { RelayNetworkLayerRequestBatch as J, RelayNetworkLayer as K, urlMiddleware as $, authMiddleware as V } from "react-relay-network-modern";
var R = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function A(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
function q(s) {
  if (s.__esModule) return s;
  var d = s.default;
  if (typeof d == "function") {
    var n = function a() {
      return this instanceof a ? Reflect.construct(d, arguments, this.constructor) : d.apply(this, arguments);
    };
    n.prototype = d.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(s).forEach(function(a) {
    var v = Object.getOwnPropertyDescriptor(s, a);
    Object.defineProperty(n, a, v.get ? v : {
      enumerable: !0,
      get: function() {
        return s[a];
      }
    });
  }), n;
}
var z = { exports: {} };
function X(s) {
  throw new Error('Could not dynamically require "' + s + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var P = { exports: {} };
const Y = {}, Z = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Y
}, Symbol.toStringTag, { value: "Module" })), tt = /* @__PURE__ */ q(Z);
var j;
function W() {
  return j || (j = 1, function(s, d) {
    (function(n, a) {
      s.exports = a();
    })(R, function() {
      var n = n || function(a, v) {
        var f;
        if (typeof window < "u" && window.crypto && (f = window.crypto), typeof self < "u" && self.crypto && (f = self.crypto), typeof globalThis < "u" && globalThis.crypto && (f = globalThis.crypto), !f && typeof window < "u" && window.msCrypto && (f = window.msCrypto), !f && typeof R < "u" && R.crypto && (f = R.crypto), !f && typeof X == "function")
          try {
            f = tt;
          } catch {
          }
        var O = function() {
          if (f) {
            if (typeof f.getRandomValues == "function")
              try {
                return f.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof f.randomBytes == "function")
              try {
                return f.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, b = Object.create || /* @__PURE__ */ function() {
          function t() {
          }
          return function(r) {
            var e;
            return t.prototype = r, e = new t(), t.prototype = null, e;
          };
        }(), B = {}, y = B.lib = {}, x = y.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(t) {
              var r = b(this);
              return t && r.mixIn(t), (!r.hasOwnProperty("init") || this.init === r.init) && (r.init = function() {
                r.$super.init.apply(this, arguments);
              }), r.init.prototype = r, r.$super = this, r;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var t = this.extend();
              return t.init.apply(t, arguments), t;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(t) {
              for (var r in t)
                t.hasOwnProperty(r) && (this[r] = t[r]);
              t.hasOwnProperty("toString") && (this.toString = t.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), g = y.WordArray = x.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(t, r) {
            t = this.words = t || [], r != v ? this.sigBytes = r : this.sigBytes = t.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(t) {
            return (t || _).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(t) {
            var r = this.words, e = t.words, i = this.sigBytes, u = t.sigBytes;
            if (this.clamp(), i % 4)
              for (var l = 0; l < u; l++) {
                var p = e[l >>> 2] >>> 24 - l % 4 * 8 & 255;
                r[i + l >>> 2] |= p << 24 - (i + l) % 4 * 8;
              }
            else
              for (var h = 0; h < u; h += 4)
                r[i + h >>> 2] = e[h >>> 2];
            return this.sigBytes += u, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var t = this.words, r = this.sigBytes;
            t[r >>> 2] &= 4294967295 << 32 - r % 4 * 8, t.length = a.ceil(r / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var t = x.clone.call(this);
            return t.words = this.words.slice(0), t;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(t) {
            for (var r = [], e = 0; e < t; e += 4)
              r.push(O());
            return new g.init(r, t);
          }
        }), H = B.enc = {}, _ = H.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(t) {
            for (var r = t.words, e = t.sigBytes, i = [], u = 0; u < e; u++) {
              var l = r[u >>> 2] >>> 24 - u % 4 * 8 & 255;
              i.push((l >>> 4).toString(16)), i.push((l & 15).toString(16));
            }
            return i.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(t) {
            for (var r = t.length, e = [], i = 0; i < r; i += 2)
              e[i >>> 3] |= parseInt(t.substr(i, 2), 16) << 24 - i % 8 * 4;
            return new g.init(e, r / 2);
          }
        }, m = H.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(t) {
            for (var r = t.words, e = t.sigBytes, i = [], u = 0; u < e; u++) {
              var l = r[u >>> 2] >>> 24 - u % 4 * 8 & 255;
              i.push(String.fromCharCode(l));
            }
            return i.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(t) {
            for (var r = t.length, e = [], i = 0; i < r; i++)
              e[i >>> 2] |= (t.charCodeAt(i) & 255) << 24 - i % 4 * 8;
            return new g.init(e, r);
          }
        }, o = H.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(t) {
            try {
              return decodeURIComponent(escape(m.stringify(t)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(t) {
            return m.parse(unescape(encodeURIComponent(t)));
          }
        }, c = y.BufferedBlockAlgorithm = x.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new g.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(t) {
            typeof t == "string" && (t = o.parse(t)), this._data.concat(t), this._nDataBytes += t.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(t) {
            var r, e = this._data, i = e.words, u = e.sigBytes, l = this.blockSize, p = l * 4, h = u / p;
            t ? h = a.ceil(h) : h = a.max((h | 0) - this._minBufferSize, 0);
            var C = h * l, S = a.min(C * 4, u);
            if (C) {
              for (var E = 0; E < C; E += l)
                this._doProcessBlock(i, E);
              r = i.splice(0, C), e.sigBytes -= S;
            }
            return new g.init(r, S);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var t = x.clone.call(this);
            return t._data = this._data.clone(), t;
          },
          _minBufferSize: 0
        });
        y.Hasher = c.extend({
          /**
           * Configuration options.
           */
          cfg: x.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(t) {
            this.cfg = this.cfg.extend(t), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            c.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(t) {
            return this._append(t), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(t) {
            t && this._append(t);
            var r = this._doFinalize();
            return r;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(t) {
            return function(r, e) {
              return new t.init(e).finalize(r);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(t) {
            return function(r, e) {
              return new w.HMAC.init(t, e).finalize(r);
            };
          }
        });
        var w = B.algo = {};
        return B;
      }(Math);
      return n;
    });
  }(P)), P.exports;
}
(function(s, d) {
  (function(n, a) {
    s.exports = a(W());
  })(R, function(n) {
    return n.enc.Hex;
  });
})(z);
var rt = z.exports;
const et = /* @__PURE__ */ A(rt);
var F = { exports: {} };
(function(s, d) {
  (function(n, a) {
    s.exports = a(W());
  })(R, function(n) {
    return function(a) {
      var v = n, f = v.lib, O = f.WordArray, b = f.Hasher, B = v.algo, y = [], x = [];
      (function() {
        function _(w) {
          for (var t = a.sqrt(w), r = 2; r <= t; r++)
            if (!(w % r))
              return !1;
          return !0;
        }
        function m(w) {
          return (w - (w | 0)) * 4294967296 | 0;
        }
        for (var o = 2, c = 0; c < 64; )
          _(o) && (c < 8 && (y[c] = m(a.pow(o, 1 / 2))), x[c] = m(a.pow(o, 1 / 3)), c++), o++;
      })();
      var g = [], H = B.SHA256 = b.extend({
        _doReset: function() {
          this._hash = new O.init(y.slice(0));
        },
        _doProcessBlock: function(_, m) {
          for (var o = this._hash.words, c = o[0], w = o[1], t = o[2], r = o[3], e = o[4], i = o[5], u = o[6], l = o[7], p = 0; p < 64; p++) {
            if (p < 16)
              g[p] = _[m + p] | 0;
            else {
              var h = g[p - 15], C = (h << 25 | h >>> 7) ^ (h << 14 | h >>> 18) ^ h >>> 3, S = g[p - 2], E = (S << 15 | S >>> 17) ^ (S << 13 | S >>> 19) ^ S >>> 10;
              g[p] = C + g[p - 7] + E + g[p - 16];
            }
            var L = e & i ^ ~e & u, N = c & w ^ c & t ^ w & t, I = (c << 30 | c >>> 2) ^ (c << 19 | c >>> 13) ^ (c << 10 | c >>> 22), Q = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25), k = l + Q + L + x[p] + g[p], U = I + N;
            l = u, u = i, i = e, e = r + k | 0, r = t, t = w, w = c, c = k + U | 0;
          }
          o[0] = o[0] + c | 0, o[1] = o[1] + w | 0, o[2] = o[2] + t | 0, o[3] = o[3] + r | 0, o[4] = o[4] + e | 0, o[5] = o[5] + i | 0, o[6] = o[6] + u | 0, o[7] = o[7] + l | 0;
        },
        _doFinalize: function() {
          var _ = this._data, m = _.words, o = this._nDataBytes * 8, c = _.sigBytes * 8;
          return m[c >>> 5] |= 128 << 24 - c % 32, m[(c + 64 >>> 9 << 4) + 14] = a.floor(o / 4294967296), m[(c + 64 >>> 9 << 4) + 15] = o, _.sigBytes = m.length * 4, this._process(), this._hash;
        },
        clone: function() {
          var _ = b.clone.call(this);
          return _._hash = this._hash.clone(), _;
        }
      });
      v.SHA256 = b._createHelper(H), v.HmacSHA256 = b._createHmacHelper(H);
    }(Math), n.SHA256;
  });
})(F);
var nt = F.exports;
const ot = /* @__PURE__ */ A(nt), it = (s, d) => {
  const n = new URL(s);
  for (const [a, v] of Object.entries(d)) {
    const f = typeof v == "object" ? JSON.stringify(v) : String(v);
    n.searchParams.append(a, f);
  }
  return n.toString();
}, st = (s = {}) => (d) => async (n) => {
  if (n instanceof J)
    return d(n);
  const {
    name: a,
    operationKind: v,
    text: f
  } = n.operation, O = {
    extensions: {
      persistedQuery: {
        sha256Hash: f && ot(f).toString(et),
        version: 1
      }
    },
    operationName: a,
    variables: n.variables
  }, b = n.fetchOpts.method;
  if (s.useGETForHashedQueries && v === "query") {
    var B;
    n.fetchOpts.method = "GET", (B = n.fetchOpts) === null || B === void 0 || delete B.body, n.fetchOpts.url && (n.fetchOpts.url = it(n.fetchOpts.url, O));
  } else
    n.fetchOpts.body = JSON.stringify(O);
  const y = await d(n);
  if (y.errors && y.errors.length === 1) {
    if (y.errors[0].message === "PersistedQueryNotSupported")
      return y;
    if (y.errors[0].message === "PersistedQueryNotFound")
      return n.fetchOpts.method = b, n.fetchOpts.body = JSON.stringify(Object.assign({}, O, {
        query: f
      })), d(n);
  }
  return y;
}, at = ({
  authOptions: s,
  urlOptions: d
}) => new K([$({
  credentials: "include",
  ...d
}), V({
  ...s
}), st({
  useGETForHashedQueries: !0
})]);
function lt(s = {
  authOptions: {
    allowEmptyToken: !0
  },
  urlOptions: {
    headers: {
      apikey: T.graphql.apiKey
    },
    method: "POST",
    url: T.graphql.host
  }
}, d = {}, n) {
  return new D({
    ...d,
    network: at(s),
    store: new G(new M(n))
  });
}
export {
  R as a,
  lt as c,
  A as g
};
//# sourceMappingURL=environment-BQ4WWa7b.mjs.map
